import { useState, useEffect } from "react";
import Card from "@material-tailwind/react/Card";
import CardHeader from "@material-tailwind/react/CardHeader";
import CardBody from "@material-tailwind/react/CardBody";
import CardFooter from "@material-tailwind/react/CardFooter";
import H5 from "@material-tailwind/react/Heading5";
import InputIcon from "@material-tailwind/react/InputIcon";
import Checkbox from "@material-tailwind/react/Checkbox";
import Button from "@material-tailwind/react/Button";
import Page from "../components/login/Page";
import Container from "../components/login/Container";
import { useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { RootContext } from "../App";
import Dialog from '@mui/material/Dialog';
import DialogBody from '@mui/material/DialogTitle';
import DialogHeader from '@mui/material/DialogTitle';
import DialogFooter from '@mui/material/DialogTitle';
import axiosInstance from "../config/axios";

import axios from "axios";

export default function Login() {

  let history = useHistory();
  const { t } = useTranslation();
  const [dataLogin] = useState({
    username: "",
    password: "",
    code: "",
  });

  // 2FA Generate State
  const [show2faGenerate, setShow2faGenerate] = useState(false);
  const [secret, setSecret] = useState(null);
  const [code, setCode] = useState(null);
  const [qrImage, setQrImage] = useState(null);

  // 2FA Verify State
  const [show2faVerify, setShow2faVerify] = useState(false);

  const changeValueLogin = (key, value) => {

    if (key === "username") {

      dataLogin.username = value;
    } else if (key === "password") {

      dataLogin.password = value;
    } else if (key === "code") {

      dataLogin.code = value;
    }
  };

  const changeNewSecret = (key, value) => {

      setCode(value);
  };

  const login = async (dispatch) => {

    try {

      setShow2faGenerate(false);
      setShow2faVerify(false);

      axios
        .post(`${process.env.REACT_APP_URL_BACKEND}/api/bo/do_login`, dataLogin)
        .then((res) => {

          let dataResponse  = res.data
          let responseCode  = dataResponse.code;
          let nextAction    = dataResponse.data.next ?? 0;

          if( responseCode !== 0 ){ return }

          if( nextAction === "generate-2fa" ){ 

            setQrImage(dataResponse.data.qrimg)
            setSecret(dataResponse.data.secret)
            setShow2faGenerate(true);
          }

          if( nextAction === "verify-2fa" ){

            setShow2faVerify(true);
          }

          if( nextAction === 0 ){

            localStorage.setItem("access_token", res.data.data.token);
            localStorage.setItem("username", dataLogin.username);
            window.location.href = "/"
          }

        })
        .catch((error) => {

          if(error.response){

            dataLogin.code = '';

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          }else{
           
          }
        });
    } catch (error) {

      console.log("ERROR: ", error);
    }
  };

  const verifynew2fa = () => {

    setShow2faGenerate(false);

    try {
        axiosInstance.post(`${process.env.REACT_APP_URL_BACKEND}/api/bo/verifynew2fa`, {
            username: dataLogin.username,
            secret  : secret,
            code    : code
        }).then((res) => { 

          dataLogin.code = code;
          login();
        })
        .catch((error) => {

            if(error.response){

                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: error.response.data.message,
                });
            }
        });
    } catch (error) { }
  };

  const handleKeyPress = (event, dispatch) => {

    if (event.key === "Enter") {

      login(dispatch);
    }
  };

  const checkIsLogin = () => {

    const token = localStorage.getItem("access_token");
    if (token) {
      
      history.push("/");
    }
  };

  useEffect(() => {

    checkIsLogin();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <RootContext.Consumer>
      {(ctx) => (
        <Page>
          <Container>
            <Card>
              <CardHeader color="lightBlue">
                <H5 color="white" style={{ marginBottom: 0 }}>
                  {t("login")}
                </H5>
              </CardHeader>

              <CardBody>
                <div className="mb-12 px-4 bg-bb">
                  <InputIcon
                    type="email"
                    color="lightBlue"
                    placeholder="username"
                    iconName="person"
                    onKeyPress={(e) => handleKeyPress(e, ctx.dispatch)}
                    onChange={(input) =>
                      changeValueLogin("username", input.target.value)
                    }
                  />
                </div>
                <div className="mb-8 px-4">
                  <InputIcon
                    type="password"
                    color="lightBlue"
                    placeholder="Password"
                    iconName="lock"
                    onKeyPress={(e) => handleKeyPress(e, ctx.dispatch)}
                    onChange={(input) =>
                      changeValueLogin("password", input.target.value)
                    }
                  />
                </div>
                <div className="mb-4 px-4">
                  <Checkbox
                    color="lightBlue"
                    text="Remember Me"
                    id="remember"
                  />
                </div>
              </CardBody>
              <CardFooter>
                <div className="flex justify-center bg-bb">
                  <Button
                    color="lightBlue"
                    buttonType="link"
                    size="lg"
                    ripple="dark"
                    onClick={() => login(ctx.dispatch)}
                  >
                    {t('login')}
                  </Button>
                </div>
              </CardFooter>
            </Card>

            {/* Modal for 2FA Generate*/}
            <Dialog open={show2faGenerate} onClose={() => setShow2faGenerate(false)}>
                <DialogHeader>Scan QR Code</DialogHeader>
                <DialogBody>
                    {qrImage ? (
                      <div className="flex flex-col items-center">
                        <img 
                            src={qrImage} 
                            alt="Google Authenticator QR" 
                            className="mx-auto"
                        />
                        <InputIcon
                            type="text"
                            color="lightBlue"
                            placeholder="Enter verification code"
                            iconName="lock"
                            onChange={(input) => changeNewSecret("code", input.target.value)}
                        />
                      </div>
                    ) : (
                        <p>Loading QR...</p>
                    )}
                </DialogBody>
                <DialogFooter>
                  <div className="flex flex-col items-center">
                    <Button color="lightBlue" onClick={verifynew2fa}>
                        Verify
                    </Button>
                  </div>
                </DialogFooter>
            </Dialog>
            {/* Modal for 2FA Scan */}

            {/* Modal for 2FA Verify*/}
            <Dialog open={show2faVerify} onClose={() => setShow2faVerify(false)}>
                <DialogBody>
                    <InputIcon
                        type="text"
                        color="lightBlue"
                        placeholder="Enter verification code"
                        iconName="lock"
                        onChange={(input) => changeValueLogin("code", input.target.value)}
                    />
                </DialogBody>
                <DialogFooter>
                  <div className="flex flex-col items-center">
                    <Button color="lightBlue" onClick={login}>
                        Verify
                    </Button>
                  </div>
                </DialogFooter>
            </Dialog>
            {/* Modal for 2FA Verify*/}

          </Container>
        </Page>
      )}
    </RootContext.Consumer>
  );
}
